module.exports = __webpack_public_path__ + "static/media/generic-chart-a.b189c2ab.png";